export default "__VITE_ASSET__Ddu19QOU__"